/* eslint-disable */
// @ts-nocheck
import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

export default function ToggleConnectorDialog({
  confirmationAction,
  setConfirmationAction,
  handleConfirmToggle,
}: any) {
  const close = () => setConfirmationAction({ open: false, type: "", connector: null });

  return (
    <Dialog open={confirmationAction.open} onClose={close}>
      <DialogTitle>
        {confirmationAction.type === "enable" ? "Enable Connector?" : "Disable Connector?"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {confirmationAction.type === "enable"
            ? `Are you sure you want to enable the ${confirmationAction.connector?.name} connector?`
            : `Are you sure you want to disable the ${confirmationAction.connector?.name} connector? You can enable it later.`}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={close}>Cancel</Button>
        <Button
          onClick={handleConfirmToggle}
          color={confirmationAction.type === "enable" ? "primary" : "error"}
          variant="contained"
          autoFocus
        >
          {confirmationAction.type === "enable" ? "Enable" : "Disable"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
